/* =========================================================
   VP Footer Hero — parallax background scroll effect

   IMPORTANT: You gave me the CSS class (.vp-section8-bg-layer)
   that sets up the *sizing* for a parallax layer (120% height,
   a transform + transition ready to animate), but not the JS
   that actually drives it on scroll. This file is my best-effort
   reconstruction of what that script likely does — a standard
   "oversized background image, shifted by a fraction of scroll
   position" parallax technique. If you have the original script,
   send it over and I'll swap this out for an exact match instead
   of an inferred one.
   ========================================================= */

(function () {
  var MAX_SHIFT_PERCENT = 10; // matches the 10% top offset / 20% extra height in the CSS

  function initParallaxLayer(wrap) {
    var layer = wrap.querySelector('[data-parallax-layer]');
    if (!layer) return;

    var ticking = false;
    var isActive = false;

    function update() {
      ticking = false;
      if (!isActive) return;

      var rect = wrap.getBoundingClientRect();
      var viewportH = window.innerHeight || document.documentElement.clientHeight;

      // progress: -1 when the section is entering from below the viewport,
      // 0 when centered in the viewport, +1 when leaving above it.
      var center = rect.top + rect.height / 2;
      var viewportCenter = viewportH / 2;
      var range = viewportCenter + rect.height / 2;
      var progress = range > 0 ? (viewportCenter - center) / range : 0;

      progress = Math.max(-1, Math.min(1, progress));

      var shiftPercent = progress * MAX_SHIFT_PERCENT;
      layer.style.transform = 'translateY(' + shiftPercent + '%)';
    }

    function requestUpdate() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    if (typeof IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isActive = entry.isIntersecting;
          if (isActive) requestUpdate();
        });
      });
      observer.observe(wrap);
    } else {
      // Fallback: always active if IntersectionObserver isn't supported
      isActive = true;
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);

    requestUpdate();
  }

  function initAll() {
    document.querySelectorAll('[data-parallax-wrap]').forEach(function (wrap) {
      if (wrap.dataset.vpParallaxInit === 'true') return;
      initParallaxLayer(wrap);
      wrap.dataset.vpParallaxInit = 'true';
    });
  }

  if (document.readyState === 'complete') {
    initAll();
  } else {
    window.addEventListener('load', initAll);
  }

  document.addEventListener('shopify:section:load', initAll);
})();